export const payments = {
  qrcode: {
    title: "QR Code",
    subtitle: "Scan the QR Code to pay",
  },
  addFunds: {
    title: "Add Funds",
    subtitle: "Add credits to your prepaid account",
    amount: "Amount",
    submit: "Add Funds",
    processing: "Processing...",
    error: "Error adding funds",
    success: "Funds added successfully",
    gateway: "Payment Gateway",
    bonus: "Deposit Bonus (3% - 10%)",
    total: "Total",
    note: "You are making a secure purchase.",
  },
  switchPlan: {
    title: "Switch Plan",
    subtitle: "Choose your new subscription plan",
    submit: "Switch Plan",
    processing: "Processing...",
    error: "Error switching plan",
    success: "Plan switched successfully",
  },
  history: {
    client: "Client",
    title: "Payment History",
    empty: "No payment history found",
    date: "Date",
    description: "Description",
    type: "Type",
    amount: "Amount",
    status: "Status",
    actions: "Actions",
  },
  types: {
    prepaid: "Prepaid",
    subscription: "Subscription",
    deposit_bonus: "Deposit Bonus",
  },
  status: {
    pending: "Pending",
    paid: "Paid",
    failed: "Failed",
    cancelled: "Cancelled",
  },
  pending: {
    pay: "Pay Pending",
    payNow: "Pay Now",
  },
  error: {
    loading: "Error loading payment history",
  },
};
